module.exports = __webpack_public_path__ + "img/File-jpg.d4834193.svg";